import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function Waste() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    
    },
    {
      header: "Reference No",
      accessorKey: "ReferenceNo",
    },
    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "Total Loss",
      accessorKey: "TotalLoss",
    },
    {
      header: "Ingredient Count",
      accessorKey: "IngredientCount",
    },
    {
      header: "Responsible Person",
      accessorKey: "ResponsiblePerson",
    },
    {
      header: "Note",
      accessorKey: "Note",
    },
    {
      header: "Added By",
      accessorKey: "AddedBy",
    },
    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },

  ]);
  const [data] = useState([
   
  ]);
  const [buttonData] = useState([
    {
      buttonText: "Add Waste ",
      path: "addWaste"
    },
  ]);
 
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Waste"}
        buttonData={buttonData}
      

      />
    </main>
  );
}

export default Waste;
